import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { STATUS_LABELS } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import StatusBadge from "@/components/app/StatusBadge";
import { Search } from "lucide-react";

const STATUSES = Object.keys(STATUS_LABELS);

export default function ItemsList() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("all");

  const load = async () => {
    const params = new URLSearchParams();
    if (q) params.append("q", q);
    if (status && status !== "all") params.append("status", status);
    const r = await api.get("/repairs/items?" + params.toString());
    setItems(r.data);
  };
  useEffect(() => { load(); }, []);
  useEffect(() => { load(); }, [status]);

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto" data-testid="items-list-page">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
        <div>
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-[#0a0a2e]">Prodotti in assistenza</h1>
          <p className="text-slate-500">Filtra per stato o cerca per seriale, codice, modello.</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full md:w-[520px]">
          <div className="relative flex-1">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input data-testid="items-search" className="pl-9" placeholder="Cerca seriale, codice, modello…" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} />
          </div>
          <Select value={status} onValueChange={setStatus}>
            <SelectTrigger data-testid="items-status-filter" className="sm:w-64"><SelectValue placeholder="Tutti gli stati" /></SelectTrigger>
            <SelectContent className="max-h-72">
              <SelectItem value="all">Tutti gli stati</SelectItem>
              {STATUSES.map((s) => <SelectItem key={s} value={s}>{STATUS_LABELS[s]}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="ama-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50">
            <tr className="text-left text-xs uppercase tracking-wider text-slate-500">
              <th className="py-2 px-3">Item</th>
              <th className="py-2 px-3">Cliente</th>
              <th className="py-2 px-3">Produttore</th>
              <th className="py-2 px-3">Prodotto</th>
              <th className="py-2 px-3">Seriale</th>
              <th className="py-2 px-3">Stato</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id} className="border-t border-slate-100 hover:bg-fuchsia-50/40 transition" data-testid={`item-row-${it.item_number}`}>
                <td className="py-2 px-3 font-semibold"><Link to={`/prodotti/${it.id}`} className="hover:text-[#d63384]">{it.item_number}</Link></td>
                <td className="py-2 px-3">{it.customer_name}</td>
                <td className="py-2 px-3">{it.manufacturer_name}</td>
                <td className="py-2 px-3">{it.product_code} {it.model}</td>
                <td className="py-2 px-3 font-mono text-xs">{it.serial_number || "-"}</td>
                <td className="py-2 px-3"><StatusBadge status={it.current_status} /></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="py-8 text-center text-slate-500 italic">Nessun prodotto trovato.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
